import { Typography } from '@mui/material'
import { HeaderType } from 'src/components/UI/CustomUI/organisms/Table/types'

const headers: HeaderType[] = [
    {
        id: 'publicId', 
        label: 'Public ID',
        custom: true,
        Element: (row: any): JSX.Element => {
            return (
                <a href={`/jobs/${row.id}`} target='_blank' rel='noreferrer'>
                    <Typography sx={{ fontSize: '16px', fontWeight: 400, color: '#3A66FF' }}>
                        {row?.publicId}
                    </Typography>
                </a>
            )
        }
    },
    { id: 'fullAddress', label: 'Address' },
    { id: 'city', label: 'City' },
    { id: 'state', label: 'State' },
    { id: 'zipCode', label: 'Zip' },
    { id: 'territory', label: 'Territory' },
    { id: 'totalValue', label: 'Amount' },
    { id: 'status', label: 'Status' },
]

export default headers
